var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import { getParams, getCookie } from './helpers';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-CSRFToken'] = getCookie('csrftoken');
var request = function (method, url, options) {
    if (options === void 0) { options = {}; }
    return axios(__assign({ method: method, url: url }, options))
        .then(function (_a) {
        var data = _a.data;
        return data || {};
    })
        .catch(function (err) {
        throw err;
    });
};
export var get = function (url, params, options) {
    return request('get', url, __assign(__assign({}, options), { params: getParams(params) }));
};
export var post = function (url, data, options) {
    return request('post', url, __assign(__assign({}, options), { data: data }));
};
export var put = function (url, data, options) {
    return request('put', url, __assign(__assign({}, options), { data: data }));
};
export var patch = function (url, data, options) {
    return request('patch', url, __assign(__assign({}, options), { data: data }));
};
export var del = function (url, data, options) {
    return request('delete', url, __assign(__assign({}, options), { data: data }));
};
export default {
    get: get,
    post: post,
    put: put,
    patch: patch,
    delete: del,
};
//# sourceMappingURL=request.js.map